import React from "react";
import {accountTypeNames, AccountTypes} from "@/constatants";
import {EditAccountDialog} from "@/dialog/EditAccountDialog";
import {useAccountStore} from "@/store/useAccountStore";
import {TransAccount} from "@/common/dto/TransAccount";
import {FtSelect} from "@/component/input/FtSelect";
import {FtSwitch} from "@/component/input/FtSwitch";
import styled from "styled-components";
import {FtButton} from "@/common/FtButton";
import {AddAccountDialog} from "@/dialog/AddAccountDialog";

const AccountItem = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 3px;
    padding: 8px 16px;
    cursor: pointer;
    font-size: 14px;

    &.archived {
        color: #999;
    }
`;

export function AccountsPage() {
    const accounts = useAccountStore(state => state.accounts);
    const [showDisabled, setShowDisabled] = React.useState(false);
    const [selectedType, setSelectedType] = React.useState<string | undefined>();
    const [editingAccount, setEditingAccount] = React.useState<TransAccount | undefined>();
    const [isCreating, setIsCreating] = React.useState(false);

    const filteredAccounts = React.useMemo(() => {
        return accounts.filter((account) => {
            return (selectedType === undefined || account.type === selectedType) && (showDisabled || !account.archived);
        });
    }, [accounts, selectedType, showDisabled]);

    return (
        <div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: 16}}>
                <div style={{display: 'flex', gap: 8}}>
                    <FtSelect
                        value={selectedType ?? ""}
                        emptyLabel="전체 유형"
                        values={AccountTypes}
                        labels={AccountTypes.map(type => accountTypeNames[type])}
                        onChange={(v) => setSelectedType(v || undefined)}
                    />

                    <FtSwitch label="미사용 계정 표시" checked={showDisabled} onChange={(value) => setShowDisabled(value)}/>
                </div>

                <FtButton onClick={() => setIsCreating(true)}>계정 생성</FtButton>
            </div>

            {selectedType && (
                <div style={{display: 'flex', flexWrap: 'wrap', gap: 8}}>
                    {filteredAccounts.map((account) => (
                        <AccountItem key={account.id}
                                     className={account.archived ? 'archived' : ''}
                                     onClick={() => setEditingAccount(account)}>{account.name}</AccountItem>
                    ))}
                </div>
            )}

            {!selectedType && (
                <div style={{display: 'flex', flexDirection: 'column', gap: 16}}>
                    {AccountTypes.map((type) => {
                            const accountsOfType = filteredAccounts.filter(account => account.type === type);
                            if (accountsOfType.length === 0) {
                                return null;
                            }
                            return (
                                <div key={type}>
                                    <h3 style={{margin: '8px 0'}}>{accountTypeNames[type]}</h3>
                                    <div style={{display: 'flex', flexWrap: 'wrap', gap: 8}}>
                                        {accountsOfType.map((account) => (
                                            <AccountItem key={account.id}
                                                         className={account.archived ? 'archived' : ''}
                                                         onClick={() => setEditingAccount(account)}>{account.name}</AccountItem>
                                        ))}
                                    </div>
                                </div>
                            );
                        }
                    )}
                </div>
            )}

            {
                editingAccount &&
                <EditAccountDialog
                    show={true}
                    account={editingAccount}
                    onHide={() => setEditingAccount(undefined)}
                />
            }

            { isCreating && (
                <AddAccountDialog handleClose={() => setIsCreating(false)}/>
            )}
        </div>
    );
}
